
import { showSnackbar } from 'utils/snack_bar/store/action';
import { CREATE_SERIES, DELETE_SERIES, UPDATE_SERIES } from '../graphql/mutation';
import { FETCH_SERIES_BY_CATEGORY_ID } from '../graphql/query';
import { actionTypes, UpdateSeriesInput, VideoSeriesInput, VideoSeriesProps } from './actionType';
import { executeMutation, executeQuery } from 'utils/services/apiServices';

export const fetchVideoSeriesRequest = () => ({
    type: actionTypes.FETCH_VIDEO_SERIES_REQUEST
});

export const fetchVideoSeriesSuccess = (payload: VideoSeriesProps[]) => ({
    type: actionTypes.FETCH_VIDEO_SERIES_SUCCESS,
    payload
});

export const fetchVideoSeriesFail = (payload: string) => ({
    type: actionTypes.FETCH_VIDEO_SERIES_FAIL,
    payload
});

export const fetchVideoSeries = (category_id:string) => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchVideoSeriesRequest());
            const input = {
                category_id: category_id
            };
            const response = await executeQuery(FETCH_SERIES_BY_CATEGORY_ID,input);
            const jsonData = response.data?.fetchSeriesByCategoryId;
            if (jsonData?.error === null) {
                dispatch(fetchVideoSeriesSuccess(jsonData?.data.series));
            } else {
                dispatch(fetchVideoSeriesFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchVideoSeriesFail('Failed to fetch VideoSeries'));
        }
    };
};

//Create Series
export const createVideoSeriesSuccess= (payload: VideoSeriesProps) => ({
    type: actionTypes.CREATE_VIDEO_SERIES_SUCCESS,
    payload
});
export const createVideoSeriesFail= (payload: string) => ({
    type: actionTypes.CREATE_VIDEO_SERIES_SUCCESS,
    payload
});
export const createVideoSeries = (input: VideoSeriesInput) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                input:input
            }
            const response = await executeMutation(CREATE_SERIES, inputData);
            const jsonData = response.data?.createSeries;
            if (jsonData?.error === null) {
                dispatch(createVideoSeriesSuccess(jsonData?.data.video_series));
                 dispatch(showSnackbar('Success! series created.'));
            } else {
                dispatch(createVideoSeriesFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(createVideoSeriesFail('Something went wrong, Try again later'))
        }
    };
};

//Update Series
export const updateVideoSeriesSuccess= (payload: VideoSeriesProps) => ({
    type: actionTypes.UPDATE_VIDEO_SERIES_SUCCESS,
    payload
});
export const updateVideoSeriesFail= (payload: string) => ({
    type: actionTypes.UPDATE_VIDEO_SERIES_FAIL,
    payload
});
export const updateVideoSeries = (input: UpdateSeriesInput) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                input:input
            }
            const response = await executeMutation(UPDATE_SERIES, inputData);
            const jsonData = response.data?.updateSeries;
            if (jsonData?.error === null) {
                dispatch(updateVideoSeriesSuccess(jsonData?.data.video_series));
                 dispatch(showSnackbar('Success! series updated.'));
            } else {
                dispatch(updateVideoSeriesFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(updateVideoSeriesFail('Something went wrong, Try again later'))
        }
    };
};

//delete Series
export const deleteVideoSeriesSuccess= (payload: string) => ({
    type: actionTypes.DELETE_VIDEO_SERIES_SUCCESS,
    payload
});
export const deleteVideoSeriesFail= (payload: string) => ({
    type: actionTypes.DELETE_VIDEO_SERIES_FAIL,
    payload
});
export const deleteVideoSeries = (series_id: string, folder_id: string) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                series_id:series_id,
                folder_id:folder_id
            }
            const response = await executeMutation(DELETE_SERIES, inputData);
            const jsonData = response.data?.deleteSeries;
            if (jsonData?.error === null) {
                dispatch(deleteVideoSeriesSuccess(series_id));
                dispatch(showSnackbar('Success! series deleted.'));
            } else {
                dispatch(deleteVideoSeriesFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(deleteVideoSeriesFail('Something went wrong, Try again later'));
        }
    };
};



